module.exports = __webpack_public_path__ + "static/media/section-header-1.5e9aa40f.jpg";